import { CommonService, PartRequestService, PartAvailabilitySubmitModel } from 'api-new/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type PartsAvailabilityInput = {
  id: number;
  requestBody?: PartAvailabilitySubmitModel;
};

export const usePartsAvailabilityMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof PartRequestService.postPartsAvailability>>,
      QueryError,
      PartsAvailabilityInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ id, requestBody }: PartsAvailabilityInput) => {
      return PartRequestService.postPartsAvailability(id, requestBody);
    },
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully updated!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
